export const schemaString = (
    date: string,
    options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    },
    lang: string = "en-US",
) => {
    return new Date(date).toLocaleDateString(lang, options);
};

export const getSeoOptions = (content, model) => {
    const seo = content.data || false
    const title = getTitle(seo, content, model)
    const description = getDescription(seo, content, model)
    const image = getImage(seo, content, model)

    const options = {
        title,
        description,
        webpage: {
            datePublished: schemaString(content?.firstPublished) || false,
            dateModified: schemaString(content?.lastUpdated) || false,
            image,
        }
    };

    return options;
};

const getTitle = (seo, content, model) => {
    if (seo?.title && seo.title.trim() != '') return seo.title;
    // Page Title
    let title = content?.data?.title || content?.name;
    // Fail Safe, get Builder Page Name
    if (!title) title = content.data?.name;
    return title;
};

const getDescription = (seo, content, model) => {
    if (seo?.description && seo.description.trim() != '') return seo.description;
    let description = content.data?.description || content.data?.shortDescription;
    return description;
};

const getImage = (seo, content, model) => {
    if (seo?.shareImage && seo.shareImage.trim() !== '') return seo.shareImage;
    if (content?.data?.image && content.data.image.trim() !== '') return content.data.image;
    let image = '/social.jpg';
    return image;
};
